import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import { Chrome } from 'vue-color';

Vue.use(BootstrapVue);
Vue.use(Chrome);

const requireComponent = require.context('.', true, /Base[\w-]+\.vue$/);

requireComponent.keys().forEach((fileName) => {
  // Get the component config
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.replace(/^\..*\//, '').replace(/\.\w+$/, '');
  // Globally register the component
  Vue.component(componentName, componentConfig.default || componentConfig);
});
